
const FieldExtended = ({value, onChange, style={}, record, editRender, ...rest}) => {
    return editRender ? editRender({record}) : null;
}

export default FieldExtended;